







































































































import { Vue, Component } from 'vue-property-decorator';
import { mdbContainer, mdbBtn, mdbRow, mdbCol } from '@folky-tools/mdbvue';
import SuggestPwaInstall from '@/components/shared/SuggestPwaInstall.vue';

@Component({ components: { mdbContainer, mdbBtn, mdbRow, mdbCol, SuggestPwaInstall } })
export default class InstallPWAView extends Vue {
    private $deviceSniffing: any;
    private navbarClasses: string = '';
    private currentCampaign: any = '';
    private browserPlatform: string = '';
    private isCurrentCampaignOfficial: boolean = false;
    // bonokanpaina is not a real campaign: it is the neutral id of the install QR in the generic merchant guide.
    private officialCampaigns: string[] = ['arrigobono', 'bonobalma', 'igorrebonodenda', 'bizkaiarepara', 'ugaobono', 'lekittobonoa', 'leioaindartubonoa', 'ondarroakobonoa', 'bonoetxebarri', 'mxbonua', 'amorebono', 'bonokanpaina'];

    // Only the button for the visitor's platform is offered. $deviceSniffing reports windows, android,
    // macintosh, ipad, iphone or other; there is no macOS or Linux label, so every desktop falls back to the
    // Windows one. Note that iPadOS 13+ reports itself as Macintosh, so a modern iPad lands there too.
    private get installPlatform(): string {
        if (this.browserPlatform === 'android') {
            return 'android';
        }
        if (this.browserPlatform === 'iphone' || this.browserPlatform === 'ipad') {
            return 'ios';
        }
        return 'windows';
    }

    // Forced open, so it ignores the device checks and any earlier dismissal that gate the automatic
    // suggestion elsewhere. On this page the visitor came to install, so the sheet is the point of the page.
    private openInstallSheet(): void {
        (this.$refs.installSheet as any).open();
    }

    private mounted(): void {
        this.$root.$emit('changeNavbarClasses', this.navbarClasses);
        this.$root.$emit('change-active-page', 'views.info.installPWAView.title');

        this.browserPlatform = this.$deviceSniffing.getBrowserInfo().platform;

        this.currentCampaign = this.$route.query.campaign ? this.$route.query.campaign : '';

        this.isCurrentCampaignOfficial = this.officialCampaigns.includes(this.currentCampaign);

        this.openInstallSheet();
    }
}
